import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typhography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Grid from "@mui/material/Grid";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { grey } from "@mui/material/colors";

import useStore from "../config/store";
import { useTranslation } from 'react-i18next';

const color1 = grey[700];
const color2 = grey[800];

function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name) {
  name = name.name;
  if (name?.split(" ").length > 1) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        width: 56,
        height: 56,
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]
        }`.toUpperCase(),
    };
  } else {
    return {
      sx: {
        bgcolor: stringToColor(name),
        width: 56,
        height: 56,
      },
      children: `${name[0]}${name[1]}`.toUpperCase(),
    };
  }
}

const ProjectCard = ({
  name,
  handleOpen,
  position,
  projectId,
  imgPath,
  role,
  language,
}) => {
  const [openDial, setOpenDial] = useState(false);
  const navigate = useNavigate();
  const { setProject, setProjectName, setLanguage } = useStore.getState();
  const { t } = useTranslation();

  if (name === "fraudes") {
    imgPath = "";
  }

  const handleClick = () => {
    setOpenDial(!openDial);
  };

  const handleCliCkAway = () => {
    setOpenDial(false);
  };

  const clickCard = (e) => {
    e.preventDefault();
    setProject(projectId);
    setProjectName(name);
    setLanguage(language);
    navigate(`/`);
  };

  const actions = [
    {
      icon: (
        <EditIcon onClick={() => handleOpen("edit", position)} />
      ),
      name: t('edit'),
    },
    {
      icon: (
        <DeleteIcon onClick={() => handleOpen("delete", position)} />
      ),
      name: t('delete'),
    },
  ];

  // Función para obtener el texto del idioma
  const getLanguageLabel = (lang) => {
    switch (lang) {
      case 'es':
        return 'Español';
      case 'en':
        return 'English';
      default:
        return 'Español';
    }
  };

  // Función para obtener el color del chip según el idioma
  const getLanguageColor = (lang) => {
    switch (lang) {
      case 'es':
        return 'primary';
      case 'en':
        return 'secondary';
      default:
        return 'primary';
    }
  };

  return (
    <Card
      elevation={8}
      sx={[
        {
          margin: 3,
          color: color1,
          py: 4
        },
        (_theme) => ({
          "&:hover": {
            color: color2,
          },
        }),
      ]}
    >
      <CardHeader
        sx={[
          {
            position: "relative",
            p: 1,
            m: 1,
            height: 136,
          },
        ]}
        title={
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imgPath ? (
              <Avatar
                {...stringAvatar({ name })}
                src={imgPath}
                sx={{
                  background: "lightgreen",
                  width: 56, // Ajusta el ancho
                  height: 56, // Ajusta la altura
                }}
              />
            ) : (
              <Avatar
                {...stringAvatar({ name })}
                sx={{
                  width: 56, // Ajusta el ancho
                  height: 56, // Ajusta la altura
                }}
              />
            )}

            <Typhography
              variant="h5"
              component="h3"
              onClick={clickCard}
              sx={[
                {
                  textAlign: "center",
                  mt: 1,
                },
                (theme) => ({
                  "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }),
              ]}
            >
              {name}
            </Typhography>

            <Chip
              label={getLanguageLabel(language)}
              color={getLanguageColor(language)}
              size="small"
              sx={{
                mt: 3,
                fontSize: "0.75rem",
                height: 24,
              }}
            />
          </Box>
        }
        action={
          role === "user" ? null : (
            <ClickAwayListener onClickAway={handleCliCkAway}>
              <SpeedDial
                ariaLabel="SpeedDial"
                icon={<SpeedDialIcon /* openIcon={<SettingsIcon />} */ />}
                direction="down"
                FabProps={{ size: "medium", border: "none", color: "inherit" }}
                onClick={handleClick}
                elevation={0}
                open={openDial}
              >
                {["super-admin", "admin-grafton", "admin"].includes(role) &&
                  actions.map((action) => (
                    <SpeedDialAction
                      key={action.name}
                      icon={action.icon}
                      tooltipTitle={action.name}
                      onClick={handleClick}
                      delay={1}
                    />
                  ))}
              </SpeedDial>
            </ClickAwayListener>
          )
        }
      ></CardHeader>
    </Card>
  );
};

export default ProjectCard;